// @ts-nocheck
import { Amplify, Auth } from 'aws-amplify'
import awsconfig from './aws-exports'
Amplify.configure({
  ...awsconfig,
  DataStore: {
    syncPageSize: 250,
  },
});
Auth.configure({
  authenticationFlowType: 'CUSTOM_AUTH',
});

const imgProxyBase = awsconfig.img_proxy_base;

const copyFromDataStore = dataStoreItem => {
  const {
    createdAt,
    updatedAt,
    _version,
    _lastChangedAt,
    _deleted,
    ...item
  } = dataStoreItem
  return JSON.parse(JSON.stringify(item))
}

enum HubEvents {
  itemAdd = "addedItem",
  itemUpdate = "updatedItem",
  itemDelete = "deletedItem",
  orderSave = "savedOrder",
}

export { copyFromDataStore, HubEvents, imgProxyBase }
